import React from 'react'
import { ThemeProvider } from '@sainsburys-tech/theme-provider'
import './styles/global.css'
import Router from './components/Router'
import Head from './components/Head'
import { Footer } from './components/Footer'
import { useSurveyTheme } from './hooks/useSurveyTheme'

const App: React.FC = () => {
  const theme = useSurveyTheme()
  return (
    <ThemeProvider brand={theme.name} className="fable:h-full">
      <Head />
      <Router />
      <Footer />
    </ThemeProvider>
  )
}

export default App
